 <template>
  <div class="edit-notification">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"
          ><strong>{{ $t("notification") }}</strong></mdb-card-title
        >
      </mdb-card-header>
      <mdb-card-body v-if="this.loadReady === true">
        <ChainSelection v-on:member="member" :content="notification" />
        <mdb-row>
          <mdb-col md="12">
            <GoogleMap
              v-on:marker-moved="markerMoved"
              :marker="computedMarker"
              class="google-map"
            />
          </mdb-col>
          <mdb-col md="12" class="mt-3">
            <p class="h5">{{ $t("notification_radius") }}</p>
            <Slider
              :initialValue="marker.radius / 1000"
              :sliderData="sliderData"
              v-on:radius="selectedRadius"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-5">
          <mdb-col md="12">
            <p class="h5">{{ $t("notification_content") }}</p>
          </mdb-col>
          <mdb-col>
            <mdb-input
              v-model="title"
              v-if="this.loadReady === true"
              type="text"
              icon="quote-right"
              :label="$t('notification_title')"
            />
          </mdb-col>
          <mdb-col>
            <Categories
              v-on:categories="selectedCategories"
              v-if="this.loadReady === true"
              :multipleSelected="false"
              :category-id="categoryId"
            />
          </mdb-col>
          <mdb-col>
            <NotificationGrouping
              v-on:groups="selectedGroups"
              :notificationGroupsId="groups"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <DateTimePicker
              v-on:datetime-changed="dateTimeChanged"
              v-if="dateTime.length > 0 && !isSimpleNotification()"
              :date-time="dateTime"
              :title="$t('notification_datepicker_title')"
            />
          </mdb-col>
          <mdb-col md="12">
            <mdb-btn
              @click="saveNotification"
              color="indigo"
              class="white-text"
              icon="paper-plane"
              >{{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbInput,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
} from "mdbvue";
import ChainSelection from "../components/ChainSelection.vue";
import GoogleMap from "./GoogleMap.vue";
import Slider from "./Slider.vue";
import Categories from "./Categories.vue";
import DateTimePicker from "./DateTimePicker.vue";
import NotificationGrouping from "./NotificationGrouping.vue";
import moment from "moment";

export default {
  name: "EditNotification",
  components: {
    mdbRow,
    mdbCol,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    ChainSelection,
    GoogleMap,
    Slider,
    Categories,
    DateTimePicker,
    NotificationGrouping,
  },
  props: {
    notificationType: String,
    unionmemberid: {
      type: String,
      default: "",
    },
    defaultMarker: Object,
  },
  methods: {
    defaultDateTime() {
      var m = moment().add(7, "days");
      m.set({ hour: 12, minute: 0, second: 0, millisecond: 0 });
      return m.format("YYYY-MM-DD HH:mm");
    },
    defaultNowDateTime() {
      var m = moment();
      return m.format("YYYY-MM-DD HH:mm");
    },
    setUnionMemberId(val) {
      this.localUnionMemberId = val;
    },
    loadNotification() {
      if (!this.isNewNotification()) {
        this.getNotification(this.getNotificationId());
      } else {
        this.loadReady = true;
      }
    },
    getNotificationId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    isSimpleNotification() {
      return (
        this.notificationType.localeCompare(
          this.$store.state.simplenotification
        ) === 0
      );
    },
    isNewNotification() {
      return this.getNotificationId() === 0;
    },
    member(member) {
      if (member === undefined) return;
      this.retailer = member;
      if (this.notificationFromBackend === false) {
        this.marker.position.lat = Number(member.lat);
        this.marker.position.lng = Number(member.lng);
        this.createMarker();
      }
      this.notificationFromBackend = false;
    },
    dateTimeChanged(val) {
      if (this.dateTime.localeCompare(val) !== 0) {
        this.dateTime = val;
      }
    },
    createMarker() {
      var marker = {
        name: "Position",
        position: {
          lat: Number(this.marker.position.lat),
          lng: Number(this.marker.position.lng),
        },
        radius: this.marker.radius,
      };
      this.marker = marker;
    },
    markerMoved(val) {
      this.marker.position.lat = val.getPosition().lat();
      this.marker.position.lng = val.getPosition().lng();
      this.createMarker();
      console.log(val);
    },
    selectedGroups(value, text) {
      this.groups = value.toString();
      console.log(value, text);
    },
    selectedRadius(val) {
      this.marker.radius = val * 1000;
      this.createMarker();
    },
    selectedCategories(value, text) {
      this.category_id = value;
      console.log(value, text);
    },
    getNotification(id) {
      this.$notify.info({
        message: this.$t("loading_notification"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(this.getnotificationpath + id)
        .then((response) => {
          if (response.status == 200) {
            this.notification = response.data.notifications[0];
            setTimeout(() => this.fillPage(), 2000);
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    fillPage() {
      this.retailer = {
        id: this.notification.retailer_id,
      };
      this.marker.name = this.title = this.notification.title;
      this.marker.position.lat = Number(this.notification.lat);
      this.marker.position.lng = Number(this.notification.lng);
      this.notificationFromBackend = true;
      this.dateTime = this.notification.due;
      this.marker.radius = this.notification.radius * 1000;
      this.createMarker();
      this.categoryId = this.category_id = parseInt(
        this.notification.category_id
      );
      this.title = this.notification.title;
      this.localUnionMemberId = this.notification.unionmember_id;
      this.groups = this.notification.groups;
      this.loadReady = true;
    },
    saveNotification() {
      this.postData = {
        id: this.getNotificationId(),
        sessionid: this.$store.getters.getToken,
        unionmember_id: this.localUnionMemberId,
        retailer_id: this.retailer.id,
        groups: this.groups,
        title: this.title,
        lat: this.marker.position.lat,
        lng: this.marker.position.lng,
        category_id: this.category_id,
        radius: this.marker.radius / 1000,
        due: this.isSimpleNotification()?this.defaultNowDateTime():this.dateTime,
      };
      console.log(this.postData);
      this.$http
        .post(this.savenotificationpath, JSON.stringify(this.postData))
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("adding_notification_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          this.$emit("modal-ok");
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("adding_notification_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          this.$emit("modal-ok");
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
  computed: {
    computedMarker() {
      return this.marker;
    },
  },
  mounted() {
    this.loadNotification();
  },
  data() {
    return {
      savenotificationpath: "/1.0/front/notification",
      getnotificationpath: "/1.0/front/notification/",
      notification: null,
      notificationFromBackend: false,
      localUnionMemberId: this.unionmemberid,
      advertisementid: null,
      retailer: null,
      title: "",
      dateTime: this.defaultDateTime(),
      formattedDateTime: "",
      category_id: null,
      groups: "",
      categoryId: 0,
      marker: this.defaultMarker,
      loadReady: false,
      sliderData: [
        1, 2, 3, 5, 7, 10, 15, 20, 30, 40, 50, 70, 100, 200, 300, 500, 700,
        1000, 1500,
      ],
    };
  },
};
</script>

<style>
.google-map {
  height: 300px;
  width: auto;
}
</style>
